import { NavLink } from 'react-router-dom';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { StyledStackProps } from './types';

export const ListItemCloseIcon = styled(ListItemIcon)(() => ({
  justifyContent: 'center',
  minWidth: '32px',
  width: '32px',
  height: '32px',
  alignItems: 'center',
  borderRadius: '8px',
}));

export const ListItemOpenIcon = styled(ListItemIcon)(() => ({
  alignItems: 'left',
  gap: '16px',
  textDecoration: 'none',
}));

export const ListItemTextStyled = styled(ListItemText)(() => ({
  margin: '0px',
  padding: '0px',
  color: '#000000',
}));

export const StyledStack = styled(Stack) <StyledStackProps>`
  padding: 6px;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.isActive ? '#E7EFF5' : '#ffffff'};
  border-radius: 8px;

  &:hover {
    background-color: #E7EFF5;
  }
`;

export const StyledOpenStack = styled(Stack) <StyledStackProps>`
  padding: 6px;
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.isActive ? '#E7EFF5' : '#ffffff'};
  border-radius: 8px;

  &:hover {
    background-color: #E7EFF5;
  }
`;

export const ListItemStyled = styled(ListItem)(() => ({
  height: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2px 10px',
}));

const linkStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-decoration: none;
  color: 000000;
  height: 100%;
  width: 100%;

  .MuiButtonBase-root {
    .MuiListItemIcon-root {
      .MuiListItemText-root {
        .MuiTypography-root {
          font-weight: 600;
          color: #000000;
        }
      }
      svg path {
        fill: 000000;
      }
    }
  }

  &.active {
    .MuiButtonBase-root {
      .MuiListItemIcon-root {
        .MuiListItemText-root {
          color: #000000;
          .MuiTypography-root {
            font-weight: 600;
            color: #000000;
          }
        }
        svg path {
          fill: #000000;
          fill-opacity: 1;
        }
      }
    }
  }
  & path {
    fill: #000000;
  }
  & svg {
    width: 24px;
  }
`;

export const NavigationLink = styled(NavLink)(linkStyles);

export const StyledListItemButton = styled(ListItemButton)(() => ({
  borderRadius: '8px',
  transition: 'all 0.2s ease-in-out',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '&.Mui-selected, &.Mui-selected:hover': {
    color: '#000000',
    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      color: '#000000',
    },
    '& path': {
      fill: '#000000',
    },
  },
  '&:hover': {
    color: '#000000',
    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      color: '#000000',
    },
    '& path': {
      fill: '#000000',
    },
  },
}));

export const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#0C2D48',
    color: '#fff',
    fontSize: '15px',
    fontWeight: 600,
    padding: '8px 16px',
    marginTop: '-8px',
  },
}));
